export {deepEqual} from 'fast-equals';
import {deepEqual} from 'fast-equals';

window.equals = deepEqual;

declare global {
  interface Window {
    equals: typeof deepEqual;
  }

  const equals: typeof deepEqual;
}
